import Container from 'react-bootstrap/Container';
import React, { Component } from 'react';
import AboutMe from './about-me';
import Header from './header';
import Experience from './experience';
import Education from './education';
import Skills from './skills';
//import Contact from './contact';
import Footer from './footer';
import Share from './share';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: 0,
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  get isMobileSized() {
    return this.state.width < 700;
  }

  render() {
    return (
      <Container fluid={true} className="content">
        <Header />
        <Container>
          <AboutMe />
          <Skills />
          <Experience />
          <Education />

          <Share />
        </Container>
        <Footer />
      </Container>
    );
  }
}

export default Home;
